$(document).ready(function () {
    var tl;

    makeScrollMagic();

    function makeScrollMagic() {
        gsap.registerPlugin(ScrollTrigger)
        tl = gsap.timeline({
            scrollTrigger: {
                id: "desktopScroll",
                markers: false,
                trigger: ".trigger-scroll-banner",
                pin: false,
                start: "top top+=60px",
                end: "top top+=60px",
                scrub: 1,
                toggleActions: "play pause resume reset",
                onEnterBack: ({
                    progress,
                    direction,
                    isActive
                }) => {
                    $('.header').removeClass("sticky animate__animated animate__fadeInDown animate__slow");
                },
                onLeave: ({
                    progress,
                    direction,
                    isActive
                }) => {
                    $('.header').addClass("sticky animate__animated animate__fadeInDown animate__slow");
                },
                invalidateOnRefresh: true,
            },
        });
    }
});